export default {
    bindings: {
        order: '=',
        title: '@'
    },
    controller: 'orderSaveController',
    template: require('../views/order.save.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/order/components/order.save.component.js